import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { ResumeLinkModule } from '@shared/resume-link/resume-link.module';

import { SocialLinksComponent } from './social-links.component';

@NgModule({
  declarations: [SocialLinksComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule, ResumeLinkModule],
  exports: [SocialLinksComponent],
})
export class SocialLinksModule {}
